import SrmDebugConstants from "../models/SrmDebugConstants.js";
const actionTypesPrefix = "srmDebug/";
const actionTypes = {
  SET_CONTEXT: SrmDebugConstants.SET_CONTEXT,
  SET_PARTIAL_CONTEXT: SrmDebugConstants.SET_PARTIAL_CONTEXT
};
const loadItemsAsyncPrefix = `${actionTypesPrefix}ITEMS_ASYNC`;
const reduxNestedKeys = {
  itemsAsyncKey: "itemsAsync"
};
export {
  actionTypes,
  loadItemsAsyncPrefix,
  reduxNestedKeys
};
//# sourceMappingURL=SrmDebug.ducks.types.js.map
